<template>
  <div
    v-bind="$attrs"
    class="origin-left scale-x-0 transition-transform duration-1000"
    :class="{
      'delay-inherited transform-none':
        inView,
    }"
  >
    <slot></slot>
  </div>
</template>

<script>
import inViewMixin from '../../mixins/in-view'

export default {
  name: 'ScaleXAnimation',
  mixins: [inViewMixin],
}
</script>